// src/components/users/RolesModal.js
import { useState, useEffect } from 'react';
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import { getAllRoles } from '../../services/roleService';

const RolesModal = ({ user, onClose, onSave }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const { user: currentUser } = useAuth();
  const [availableRoles, setAvailableRoles] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState(user.roles?.map(r => r.id) || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Загружаем доступные роли с бэкенда
    const loadAvailableRoles = async () => {
      const roles = await getAllRoles();
      setAvailableRoles(roles);
    };
    
    loadAvailableRoles();
  }, []);

  const handleRoleToggle = (roleId) => {
    setSelectedRoles(prev =>
      prev.includes(roleId)
        ? prev.filter(id => id !== roleId)
        : [...prev, roleId]
    );
  };

  const handleSave = async () => {
    setLoading(true);
    setError('');
    try {
      // Обновляем проекты и роли вместе
      const res = await api.patch(`/user/${user.id}/projects`, {
        projects: user.projects.map(p => p.id),
        role_ids: selectedRoles
      });
      
      // Получаем полные объекты ролей для обновления UI
      const roles = await getAllRoles();
      const userRoles = roles.filter(r => selectedRoles.includes(r.id));
      
      onSave(userRoles);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка при сохранении ролей');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal show" style={{ display: 'block' }} onClick={handleBackdropClick}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Роли пользователя: {user.username}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}
            
            <div className="roles-list">
              {availableRoles.length === 0 ? (
                <p>Нет доступных ролей</p>
              ) : (
                availableRoles.map(role => (
                  <div key={role.id} className="form-check">
                    <input
                      type="checkbox"
                      id={`role-${role.id}`}
                      className="form-check-input"
                      checked={selectedRoles.includes(role.id)}
                      onChange={() => handleRoleToggle(role.id)}
                    />
                    <label htmlFor={`role-${role.id}`} className="form-check-label">
                      {role.name}
                    </label>
                  </div>
                ))
              )}
            </div>
            
            {loading && <div className="text-center mt-3">Сохранение...</div>}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Отмена</button>
            <button className="btn btn-primary" onClick={handleSave}>Сохранить</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolesModal;